<template>
  <div>
    <v-row>
      <v-col cols=4>
        <v-select
          :items="statusTypes"
          :label="$translate('Select status')"
          v-model="selectedStatus"
          item-text="name"
          item-value="id"
          clearable
        >
        </v-select>
      </v-col>
      <v-col cols=4>
        <v-text-field
          v-model="addon_search"
          append-icon="mdi-magnify"
          :label="$translate('Search')"
          single-line
          hide-details
          @keydown="searchKeyDown"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=12>
        <v-data-table
          ref="reviewaddontable"
          :headers="headers"
          :items="filtered_addons"
          class="elevation-1"
          :hide-default-header="$root.isSmallScreen"
          :hide-default-footer="true"
          must-sort
          :items-per-page="1000"
          :search="addon_search"
          @click:row="rowClick"
        >
          <template v-slot:item.image="{ item }">
            <img v-if="item.version.image" :src="item.version.image" width="50" height="50" />
          </template>
          <template v-slot:item.state="{ item }">
            {{getState(item.version.state)}}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'reviewAddonsComponent',
  data: () => ({
    selectedStatus: 'review',
    addon_search: '',
    addons: []
  }),
  computed: {
    statusTypes() {
      return [{id: 'test', name: this.$translate('In development')}, {id: 'live', name: this.$translate('Published')}, {id: 'review', name: this.$translate('Under review')}];
    },
    headers() {
      return [{ text: '', value: 'image', sortable: false},{ text: this.$translate('Name'), value: 'name'}, {text: 'ID', value: 'id'}, {text: this.$translate('Developer'), value: 'version.supplier_name'},  {text: 'Version', value: 'version.version_number'}, {text: 'Status', value: 'state'}, {text: this.$translate('Last modified'), value: 'version.last_modified'}];
    },
    filtered_addons() {
      return this.addons.filter(a => a.version &&  (!this.selectedStatus || a.version.state == this.selectedStatus));
    }
  },
  mounted() {
    fetch('/api/addon/review/get').then(response => response.json() ).then(data => {
      data.forEach( (addon) => {
        addon.version = _.find(addon.versions, {state: 'review'}) || _.find(addon.versions, {state: 'test'}) || _.find(addon.versions, {state: 'live'});
      });
      this.addons = data;
    });
  },
  methods: {
    rowClick(addon) {
      this.$router.push({name: 'show', params: {addon_id: addon.id}, props: {addon: _.cloneDeep(addon)}});
    },
    getState(state) {
      switch (state) {
        case 'test': return this.$translate('In development');
        case 'review': return this.$translate('Under review');
        case 'live': return this.$translate('Published');
      }
    },
    searchKeyDown(e) {
      if (e.keyCode == 13 && this.$refs.reviewaddontable.selectableItems.length == 1) {
        this.rowClick(this.$refs.reviewaddontable.selectableItems[0]);
      }
    },
  }
}
</script>
